export default __webpack_public_path__ + "static/media/nagledno.1a0c303f.png";